/* Natural Roots — product switcher for the "bought together" block.

   Every option is already rendered by Liquid; this only toggles which one is
   visible and repoints the add-to-cart button. Nothing is calculated here, so
   currency formatting stays correct and the currency app keeps working. */
(function () {
  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function init(block) {
    if (block.hasAttribute('data-nr-fbt-ready')) return;
    block.setAttribute('data-nr-fbt-ready', 'true');

    var toggle = block.querySelector('[data-nr-fbt-toggle]');
    var panel = block.querySelector('[data-nr-fbt-panel]');
    var button = block.querySelector('[data-nr-add-variants]');

    function closePanel() {
      if (!panel || !toggle) return;
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      block.classList.remove('nr-fbtb--open');
    }

    function select(index) {
      var key = String(index);

      each(block.querySelectorAll('[data-nr-fbt-opt]'), function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-nr-fbt-opt') === key);
      });

      each(block.querySelectorAll('[data-nr-fbt-pick]'), function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-nr-fbt-pick') === key);
      });

      var activeTotal = null;
      each(block.querySelectorAll('[data-nr-fbt-total]'), function (el) {
        var on = el.getAttribute('data-nr-fbt-total') === key;
        el.classList.toggle('is-active', on);
        if (on) activeTotal = el;
      });

      if (button && activeTotal) {
        var variants = activeTotal.getAttribute('data-variants');
        if (variants) button.setAttribute('data-nr-add-variants', variants);
      }

      closePanel();
    }

    if (toggle && panel) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var opening = panel.hidden;
        panel.hidden = !opening;
        toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        block.classList.toggle('nr-fbtb--open', opening);
      });

      document.addEventListener('click', function (event) {
        if (panel.hidden) return;
        if (block.contains(event.target)) return;
        closePanel();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') closePanel();
      });
    }

    each(block.querySelectorAll('[data-nr-fbt-pick]'), function (pick) {
      pick.addEventListener('click', function (event) {
        event.preventDefault();
        select(pick.getAttribute('data-nr-fbt-pick'));
      });
    });
  }

  function boot() {
    each(document.querySelectorAll('[data-nr-fbt]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The theme editor re-renders sections without a full page load
  document.addEventListener('shopify:section:load', function () {
    setTimeout(boot, 60);
  });
})();